import { api } from "./api";

export interface Project {
  id: string;
  workspaceId: string;
  slug: string;
  name: string;
  description: string | null;
  icon: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateProjectInput {
  name: string;
  slug?: string;
  description?: string;
  icon?: string;
}

export interface UpdateProjectInput {
  name?: string;
  description?: string | null;
  icon?: string | null;
}

export const projectsApi = {
  list: () => api<Project[]>("/v1/projects"),
  get: (id: string) => api<Project>(`/v1/projects/${id}`),
  create: (input: CreateProjectInput) =>
    api<Project>("/v1/projects", { method: "POST", json: input }),
  update: (id: string, input: UpdateProjectInput) =>
    api<Project>(`/v1/projects/${id}`, { method: "PATCH", json: input }),
  remove: (id: string) =>
    api<{ id: string; deleted: true }>(`/v1/projects/${id}`, {
      method: "DELETE",
    }),
};
